export const COOKIE_NAME = 'skipDatesModal';
export const COOKIE_EXPIRES = 1000 * 60 * 60 * 24 * 30;
